<template>
  <div>
    <v-tabs v-model="activeTab"
            grow
            background-color="primary"
            dark
            center-active
            show-arrows>
      <v-tab href="#list">
        Доверенности
      </v-tab>
      <v-tab href="#sync">
        Синхронизация доверенности
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item value="list">
        <AttorneysList ref="attorneysList"/>
      </v-tab-item>
      <v-tab-item value="sync">
        <SyncAttorneysForm @imported="onImported" title="Иморт доверенности"/>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AttorneysList from '@/components/main/attorney/AttorneysList'
import SyncAttorneysForm from '@/components/main/attorney/SyncAttorneysForm'


export default {
  name: "AttorneysPage",
  components: {
    AttorneysList,
    SyncAttorneysForm
  },

  data() {
    return {
      activeTab: 'list',
    };
  },
  methods: {
    onImported() {
      this.$refs.attorneysList.loadAttorneys();
    }
  }
}
</script>

<style scoped>

</style>